export const EMPTY_OBJECT = Object.freeze({})
export const NOOP = () => undefined
export const MAX_MOBILE_WIDTH = 960
export const MAX_DESKTOP_WIDTH = 1600
export const QUINCE = 'Quince'
export const EN_US = 'en_US'
export const CONTENT_QUERY_PARAM = 'content-version'
export const NO_COLOR_OPTION_NAME = 'No Color'
